<template>
  <div class="inp_date">
    <InputBase v-bind="{ ...$attrs, ...$props }" type="date" v-on="listeners" />
    <span :class="{placeholder: !formattedValue}">{{ !formattedValue ? placeholder:formattedValue }}</span>
  </div>
</template>

<script>
import InputBase from './InputBase.vue';

export default {
  components: {
    InputBase,
  },

  model: {
    prop: 'value',
    event: 'update',
  },

  props: {
    value: String,
    placeholder: String,
  },

  computed: {
    listeners() {
      return {
        ...this.$listeners,
      };
    },
    formattedValue() {
      return this.value?.replace(/(\d{4})-(\d{2})-(\d{2})/, '$1-$2-$3');
    },
  },

  methods: {
    focus() {
      this.$el.querySelectorAll('input,select,textarea')[0]?.focus();
    },
  },
};
</script>
